// extracted by mini-css-extract-plugin
export default {"boxAttributes":"BoxAttributes_boxAttributes__5-+cZ","boxAttributes__grid":"BoxAttributes_boxAttributes__grid__aSAF7"};